module.exports = __webpack_public_path__ + "static/media/essungavapen.9d3feed3.png";